import React, { useEffect } from "react"
import { useState } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import { useLocation, useNavigate } from "react-router"
import { addRoleSchemas } from "components/Common/validation"
import { permissionsList } from "components/Common/constants"
import { useDispatch, useSelector } from "react-redux"
import {
  addNewRole,
  getRoleDetails,
  updateRoleDetails,
} from "store/actions/rolesAction"
import Spinners from "components/Shared/Spinners"
import Switch from "components/Shared/Switch"
import isPermissionEnabled from "common/isPermissionEnabled"
import { showAlert } from "store/reducers/alertReducer"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Card, CardBody, CardTitle, Col, Row, Button, Table } from "reactstrap"
import { Link } from "react-router-dom"
import BackButton from "components/Shared/BackButton"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"

const initialValues = {
  name: "",
  nameAr: "",
  description: "",
  descriptionAr: "",
}

const AddRoles = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = `${mode === "add" ? t("Add") : t("Edit")} ${t(
    "Role | Sign Burger"
  )}`

  const navigate = useNavigate()
  const location = useLocation()
  const { userRole, accountType } = useSelector(state => state.Login)

  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const dispatch = useDispatch()
  const { loading, error, isLoading, message, actionType, roleDetails } =
    useSelector(state => state.Roles)

  const [isCreateRolePermission, setIsCreateRolePermission] = useState(null)
  const [isEditRolePermission, setIsEditRolePermission] = useState(null)
  const [permissionLists, setPermissionLists] = useState([])
  const [formValues, setFormValues] = useState(initialValues)
  const [selectAll, setSelectAll] = useState(false)
  const [roleStatus, setRoleStatus] = useState(null)

  const [selectedPermissions, setSelectedPermissions] =
    useState(permissionsList)
  // IF HAVE MODE===EDIT THEN UPDATE INITAIL VALUES
  const [showSubPermissions, setShowSubPermissions] = useState(false)

  useEffect(() => {
    if (accountType !== "superadmin") {
      navigate("/dashboard")
    }
  }, [])

  useEffect(() => {
    if (mode === "edit") {
      fetchRoleDetails()
    } else {
      setSelectedPermissions(permissionsList)
    }
  }, [])

  useEffect(() => {
    if (actionType === "ROLE_DETAILS_SUCCESS_FETCHED") {
      getOldValue()
    }
  }, [actionType])

  const fetchRoleDetails = () => {
    const payload = {
      id,
    }
    dispatch(getRoleDetails({ ...payload, navigate }))
  }

  const getOldValue = () => {
    const { name, nameAr, description, descriptionAr, permissions, status } =
      roleDetails
    setFormValues({
      ...formValues,
      name,
      nameAr,
      description,
      descriptionAr,
    })
    setRoleStatus(status)
    // if (permissions.length === 0) {
    //   setSelectedPermissions(permissionsList)
    // } else {
    // Add missing static permissions to the api permissions array
    updatePermissionsWithStatic(permissions)

    // }
  }

  // console.log(selectedPermissions)

  const updatePermissionsWithStatic = apiPermissions => {
    const updatedPermissions = [...apiPermissions] // Copy API permissions

    // Add missing static permissions to the updated permissions array
    permissionsList.forEach(staticPermission => {
      const matchingApiPermission = apiPermissions.find(
        apiPermission =>
          staticPermission.category === apiPermission.category &&
          staticPermission.id === apiPermission.id
      )

      // If a matching API permission is not found, add the static permission
      if (!matchingApiPermission) {
        updatedPermissions.push({ ...staticPermission })
      }
    })

    // Merging the arrays
    const mergedArray = mergeArrays(permissionsList, apiPermissions)
    // console.log(mergedArray)

    setSelectedPermissions(mergedArray)
  }

  // Helper function to deep copy an object or array
  function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj))
  }

  // Function to merge permissions
  function mergePermissions(staticPermissions, apiPermissions) {
    const mergedPermissions = deepCopy(apiPermissions)

    staticPermissions.forEach(staticPermission => {
      const existingPermission = mergedPermissions.find(
        p => p.id === staticPermission.id
      )

      if (!existingPermission) {
        mergedPermissions.push(staticPermission)
      } else if (staticPermission.subPermissions) {
        if (!existingPermission.subPermissions) {
          existingPermission.subPermissions = []
        }
        staticPermission.subPermissions.forEach(subPerm => {
          const existingSubPerm = existingPermission.subPermissions.find(
            sp => sp.id === subPerm.id
          )
          if (!existingSubPerm) {
            existingPermission.subPermissions.push(subPerm)
          }
        })
      }
    })

    return mergedPermissions
  }

  // Function to merge static array with API array
  function mergeArrays(staticArray, apiArray) {
    const mergedArray = deepCopy(apiArray)

    staticArray.forEach(staticItem => {
      const existingItem = mergedArray.find(item => item.id === staticItem.id)

      if (!existingItem) {
        mergedArray.push(staticItem)
      } else {
        existingItem.permissions = mergePermissions(
          staticItem.permissions,
          existingItem.permissions
        )
      }
    })

    return mergedArray
  }

  const handleSwitchClick = (categoryId, permissionId) => {
    const updatedLists = permissionLists?.map(category => {
      if (category.id === categoryId) {
        return {
          ...category,
          permissions: category?.permissions?.map(permission => {
            if (permission.id === permissionId) {
              return {
                ...permission,
                enable: !permission.enable,
              }
            }
            return permission
          }),
        }
      }
      return category
    })

    // setPermissionLists(updatedLists)
  }

  useEffect(() => {
    // CHECKED SELECT ALL SWITCH IF HAVE ALL PERMISSION CHECKED
    setSelectAll(
      selectedPermissions.every(category =>
        category.permissions.every(permission => permission.isEnabled)
      )
    )
  }, [selectedPermissions])

  const handleSelectAllToggle = () => {
    const newSelectAll = !selectAll
    setSelectAll(newSelectAll)

    const updatedPermissionLists = permissionLists?.map(category => ({
      ...category,
      permissions: category?.permissions?.map(permission => ({
        ...permission,
        enable: newSelectAll,
      })),
    }))

    // setPermissionLists(updatedPermissionLists)
  }

  const handleSubmit = values => {
    const { name, nameAr, description, descriptionAr } = values

    // const updatedSelectedPermissions = selectedPermissions.map(selected => {
    //   const matchedPermission = permissionsList.find(
    //     permission => permission.id === selected.id
    //   )
    //   return matchedPermission
    //     ? {
    //         ...selected,
    //         titleAr: matchedPermission.titleAr,
    //         title: matchedPermission.title,
    //       }
    //     : selected
    // })

    const payload = {
      name,
      nameAr,
      description,
      descriptionAr,
      permissions: selectedPermissions,
      // permissions: permissionsList,
    }

    const hasViewPermission = selectedPermissions.some(permission =>
      permission.permissions.some(p => p.isEnabled && p.value === "view")
    )
    if (mode === "add") {
      if (!hasViewPermission) {
        dispatch(
          showAlert({
            text: t("Please select at least one view permission."),
            type: "error",
          })
        )
      } else {
        dispatch(addNewRole({ ...payload, navigate }))
          .then(action => {
            const { statusCode, status, msg } = action?.payload
            if (statusCode === 200 && status) {
              dispatch(showAlert({ text: msg, type: "success" }))
              navigate(`/roles`)
            } else {
              dispatch(showAlert({ text: msg, type: "error" }))
            }
          })
          .catch(error => {})
      }
    } else if (mode === "edit") {
      const updatedPayload = {
        ...payload,
        id: id,
        status: `${roleStatus}`,
      }
      if (!hasViewPermission) {
        dispatch(
          showAlert({
            text: t("Please select at least one view permission."),
            type: "error",
          })
        )
      } else {
        dispatch(updateRoleDetails(updatedPayload))
          .then(action => {
            const { statusCode, status, msg } = action?.payload
            if (statusCode === 200 && status) {
              dispatch(showAlert({ text: msg, type: "success" }))
              navigate(-1)
            } else {
              dispatch(showAlert({ text: msg, type: "error" }))
            }
          })
          .catch(error => {})
      }
    }
  }

  const handleCheckboxChange = (
    permissionGroupId,
    permissionId,
    subPermissionId = 0
  ) => {
    // console.log(permissionGroupId, permissionId, subPermissionId)

    const updatedLists = selectedPermissions.map(category => {
      if (category.id === permissionGroupId) {
        return {
          ...category,
          permissions: category.permissions.map(permission => {
            if (permission.id === permissionId) {
              if (subPermissionId === 0) {
                const newStatus = !permission.isEnabled
                return {
                  // ...permission,
                  // isEnabled: !permission.isEnabled,
                  ...permission,
                  isEnabled: newStatus,
                  subPermissions: permission.subPermissions?.map(
                    subPermission => ({
                      ...subPermission,
                      isEnabled: newStatus, // **NEW: Update all sub-permissions to match the new status**
                    })
                  ),
                }
              } else {
                return {
                  ...permission,
                  subPermissions: permission.subPermissions.map(
                    subPermission => {
                      if (subPermission.id === subPermissionId) {
                        return {
                          ...subPermission,
                          isEnabled: !subPermission.isEnabled,
                        }
                      }
                      return subPermission
                    }
                  ),
                }
              }
            }
            return permission
          }),
        }
      }
      return category
    })

    setSelectedPermissions(updatedLists)
  }

  const handleSelectAllPermissions = () => {
    const newSelectAll = !selectAll
    const updatedPermissionLists = selectedPermissions?.map(category => ({
      ...category,
      permissions: category?.permissions?.map(permission => ({
        ...permission,
        isEnabled: newSelectAll,
      })),
    }))
    setSelectedPermissions(updatedPermissionLists)
  }

  if (mode === "edit" && loading) {
    return <Spinners />
  }

  return (
    <div className="page-content add_roles_page">
      <Breadcrumbs />
      <Row>
        <Col xl={12}>
          <Formik
            enableReinitialize={true}
            initialValues={formValues}
            validationSchema={addRoleSchemas}
            onSubmit={handleSubmit}
          >
            {({ errors, touched }) => (
              <Form action="">
                <Card>
                  <CardBody>
                    <CardTitle className="d-flex align-items-center">
                      <BackButton />
                      {mode === "add" ? t("Add Role") : t("Edit Role")}
                    </CardTitle>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="name">
                            <span className="text-danger">*</span>{" "}
                            {t("Name(English)")}
                          </label>
                          <Field
                            type="text"
                            id="name"
                            name="name"
                            placeholder={t("Name(English)")}
                            className={`form-control ${
                              touched.name && errors.name ? "is-invalid" : ""
                            }`}
                          />
                          <TextError name="name" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="nameAr">
                            <span className="text-danger">*</span>{" "}
                            {t("Name(عربي)")}
                          </label>
                          <Field
                            type="text"
                            style={{ direction: "rtl" }}
                            id="nameAr"
                            name="nameAr"
                            placeholder={t("Name(عربي)")}
                            className={`form-control ${
                              touched.nameAr && errors.nameAr
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError name="nameAr" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="description">
                            {t("Description(English)")}
                          </label>
                          <Field
                            as="textarea"
                            id="description"
                            name="description"
                            rows={1}
                            placeholder={t("Description(English)")}
                            className={`form-control`}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form_field">
                          <label htmlFor="descriptionAr">
                            {t("Description(عربي)")}
                          </label>
                          <Field
                            as="textarea"
                            rows={1}
                            style={{ direction: "rtl" }}
                            id="descriptionAr"
                            name="descriptionAr"
                            placeholder={t("Description(عربي)")}
                            className={`form-control ${
                              touched.descriptionAr && errors.descriptionAr
                                ? "is-invalid"
                                : ""
                            }`}
                          />
                          <TextError name="descriptionAr" />
                        </div>
                      </div>
                      {/* <h3 className="my-3">Permissions</h3> */}
                      {/* {!permissionLists || permissionLists.length === 0 ? (
                        <p>No permissions found</p>
                      ) : (
                        <div className="">
                          <div className="d-flex align-items-center mb-3">
                            <h6 className="me-2">Select All Permission</h6>
                            <Switch
                              isChecked={selectAll}
                              onClickHandler={handleSelectAllToggle}
                            />
                          </div>
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S. No.</th>
                                <th>Category</th>
                                <th>Lists</th>
                                <th>Create</th>
                                <th>Edit</th>
                                <th>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {permissionLists.map((category, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{category.category}</td>
                                  {category.permissions.map(
                                    ({ id, name, enable }) => (
                                      <td key={id}>
                                        <div className="single_switch">
                                          <Switch
                                            isChecked={enable}
                                            onClickHandler={() =>
                                              handleSwitchClick(category.id, id)
                                            }
                                          />
                                        </div>
                                      </td>
                                    )
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      )} */}
                    </div>
                  </CardBody>
                </Card>
                <Card>
                  <CardBody>
                    <CardTitle className="d-flex align-items-center">
                      {t("Permissions")}{" "}
                      <div className="form-check ps-5">
                        <input
                          className="form-check-input"
                          id={"selectAll"}
                          type="checkbox"
                          name={"selectAll"}
                          value={selectAll}
                          onClick={handleSelectAllPermissions}
                          checked={selectAll}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={"selectAll"}
                        >
                          {selectAll ? t("Deselect") : t("Select")}{" "}
                          {t("All Permissions")}
                        </label>
                      </div>
                    </CardTitle>
                    <Row>
                      {selectedPermissions &&
                        selectedPermissions.map((permissionGroup, index) => (
                          <Col
                            className="role-col"
                            xl={4}
                            xxl={4}
                            ms={12}
                            key={index}
                          >
                            <div
                              style={{
                                border: "1px solid #eff2f7",
                                margin: 10,
                                padding: 10,
                                borderRadius: 10,
                                boxShadow:
                                  "rgba(149, 157, 165, 0.2) 0px 0px 5px",
                                paddingBottom: "15px",
                              }}
                            >
                              <h4 className="font-size-14 my-2 ms-2 font-weight-bold">
                                {language === "sa"
                                  ? permissionGroup.titleAr
                                  : permissionGroup.title}
                              </h4>
                              {/* <ul className="list-group d-flex"> */}

                              <ul className="list-group d-flex flex-column">
                                {permissionGroup.permissions.map(
                                  (permission, subIndex) => (
                                    <li
                                      // className="list-group-item role_permission_li"
                                      className="list-group-item not_allowed_cursor"
                                      key={subIndex}
                                    >
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          id={permission.id}
                                          type="checkbox"
                                          name={permission.id}
                                          onClick={() => {
                                            handleCheckboxChange(
                                              permissionGroup.id,
                                              permission.id
                                            )
                                          }}
                                          checked={permission.isEnabled}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={permission.id}
                                        >
                                          {language === "sa"
                                            ? permission.labelAr
                                            : permission.label}
                                        </label>
                                      </div>
                                      {permission.isEnabled &&
                                        permission?.subPermissions && (
                                          <ul className="list-group d-flex flex-column ms-3 mt-3">
                                            {permission?.subPermissions?.map(
                                              (
                                                subPermission,
                                                subPermissionIndex
                                              ) => (
                                                <li
                                                  // className="list-group-item role_permission_li"
                                                  className="list-group-item"
                                                  key={subPermissionIndex}
                                                >
                                                  <div className="form-check">
                                                    <input
                                                      className="form-check-input"
                                                      id={subPermission.id}
                                                      type="checkbox"
                                                      name={subPermission.id}
                                                      onClick={() => {
                                                        handleCheckboxChange(
                                                          permissionGroup.id,
                                                          permission.id,
                                                          subPermission.id
                                                        )
                                                      }}
                                                      checked={
                                                        subPermission.isEnabled
                                                      }
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      htmlFor={subPermission.id}
                                                    >
                                                      {language === "sa"
                                                        ? subPermission.labelAr
                                                        : subPermission.label}
                                                    </label>
                                                  </div>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        )}
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          </Col>
                        ))}
                    </Row>

                    <div className="col-12 mt-4">
                      <div className="d-flex align-items-center justify-content-end">
                        <Button
                          type="button"
                          color="secondary"
                          className=" mx-2"
                          onClick={() => navigate(-1)}
                        >
                          {t("Cancel")}
                        </Button>
                        <Button
                          color="success"
                          type="submit"
                          style={{ width: "fit-content" }}
                          disabled={isLoading}
                        >
                          {mode === "add" ? t("Add") : t("Save")}
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
    </div>
  )
}

export default AddRoles

// permissionsList
// setSelectedPermissions
